
























































import { Vue, Component } from 'vue-property-decorator'
import LearningCourseWare from '@api/model/learning/LearningCourseWare'
import LearningCourseModule from '@api/module/customer/learning/LearningCourseModule'

interface IndexInfo {
  chapterIndex: number
  courseWareIndex: number
}

@Component({
  filters: {
    convertNumber(value: number) {
      return {
        0: '一',
        1: '二',
        2: '三',
        3: '四',
        4: '五',
        5: '六',
        6: '七',
        7: '八',
        8: '九'
      }[value]
    }
  }
})
export default class extends Vue {
  courseWarePlayingMap = {}
  courseWareTypeMap = { 1: 'document', 2: 'video', 3: 'video' }

  get learningCourseChapterList() {
    return LearningCourseModule.learningCourseChapterList
  }

  get courseWareList() {
    return LearningCourseModule.learningCourseWareList
  }

  getLearningCourseWareListByChapterId(chapterId: string) {
    return LearningCourseModule.getLearningCourseWareListByChapterId(chapterId)
  }

  isPlaying(courseWareId: string) {
    const isPlaying = courseWareId === this.$route.params.courseWareId
    this.courseWarePlayingMap[courseWareId] = isPlaying
    return isPlaying
  }

  convertTime(val: number) {
    return this.$moment.duration(val, 'seconds').format('HH:mm:ss', { trim: false })
  }

  async play(courseWare: LearningCourseWare, indexInfo: IndexInfo) {
    this.$emit('change-courseware', { courseWare, indexInfo })
  }
}
